"use client";

import { queryOptions, useQuery } from "@tanstack/react-query";
import { getAllClients, CLIENT_ALL_GET } from "@/api/client/client";
import { useSession } from "@/hooks/useSession";

// Over-fetched so the list stays full after callers drop clients who are
// already participants.
const DEFAULT_CLIENTS_FETCH_SIZE = 20;

/**
 * The firm's first clients alphabetically, offered before the user types a
 * search. Keyed under CLIENT_ALL_GET so creating or editing a client
 * refreshes it.
 */
const defaultClientsQueryOptions = (firmId: string | undefined) =>
  queryOptions({
    // firmId in the key: choosing another organization at login keeps the
    // query cache, and the staleTime would otherwise serve the previous
    // firm's clients.
    queryKey: [CLIENT_ALL_GET, "default", firmId],
    queryFn: () =>
      getAllClients({
        sortBy: "firstname",
        asc: true,
        take: DEFAULT_CLIENTS_FETCH_SIZE,
      }),
    staleTime: 5 * 60 * 1000,
  });

export const useDefaultClients = ({ enabled = true } = {}) => {
  const { user } = useSession();
  const firmId = user?.firmId;
  return useQuery({
    ...defaultClientsQueryOptions(firmId),
    enabled: enabled && !!firmId,
  });
};
